/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.13.2.0 (NJsonSchema v10.5.2.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import {optionsTransformer} from '@sekoia/shared/requests/nswagBaseClients/baseClient';
import * as moment from 'moment';

export class BaseClient {
  getBaseUrl(_: string, parsedBaseUrl: string | undefined): string {
    if (parsedBaseUrl) {
      return parsedBaseUrl;
    }

    if (!process.env.FLUIDS_SERVICE_URL) {
      throw new Error('FLUIDS_SERVICE_URL must be set in environment');
    }

    return process.env.FLUIDS_SERVICE_URL;
  }
  
  async transformOptions(options: RequestInit) : Promise<RequestInit> {
    return optionsTransformer.addDefaultHeaders(options);
  }
}

export class TargetValueClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("https://services-fluids-dev.sekoia.one", baseUrl);
    }

    getTargetValuesForResidents(request: GetTargetValuesForResidentsRequest): Promise<TargetValueResponse[]> {
        let url_ = this.baseUrl + "/api/targetValues/query";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTargetValuesForResidents(_response);
        });
    }

    protected processGetTargetValuesForResidents(response: Response): Promise<TargetValueResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TargetValueResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TargetValueResponse[]>(<any>null);
    }

    post(request: CreateTargetValueRequest): Promise<TargetValueResponse> {
        let url_ = this.baseUrl + "/api/targetValues";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<TargetValueResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = TargetValueResponse.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TargetValueResponse>(<any>null);
    }
}

export class ReportClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("https://services-fluids-dev.sekoia.one", baseUrl);
    }

    getReport(residentIds: string[] | null | undefined, reportType: ReportType | undefined, fromDate: moment.Moment | undefined, toDate: moment.Moment | undefined, timeZone: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/report?";
        if (residentIds !== undefined && residentIds !== null)
            residentIds && residentIds.forEach(item => { url_ += "residentIds=" + encodeURIComponent("" + item) + "&"; });
        if (reportType === null)
            throw new Error("The parameter 'reportType' cannot be null.");
        else if (reportType !== undefined)
            url_ += "reportType=" + encodeURIComponent("" + reportType) + "&";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toJSON() : "") + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toJSON() : "") + "&";
        if (timeZone !== undefined && timeZone !== null)
            url_ += "timeZone=" + encodeURIComponent("" + timeZone) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetReport(_response);
        });
    }

    protected processGetReport(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }
}

export class RegistrationClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("https://services-fluids-dev.sekoia.one", baseUrl);
    }

    getRegistrationsForResidents(request: GetRegistrationsForResidentsRequest): Promise<RegistrationResponse[]> {
        let url_ = this.baseUrl + "/api/registrations/query";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetRegistrationsForResidents(_response);
        });
    }

    protected processGetRegistrationsForResidents(response: Response): Promise<RegistrationResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RegistrationResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RegistrationResponse[]>(<any>null);
    }

    post(registration: CreateRegistrationRequest): Promise<RegistrationResponse> {
        let url_ = this.baseUrl + "/api/registrations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(registration);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<RegistrationResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = RegistrationResponse.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RegistrationResponse>(<any>null);
    }
}

export class RegistrationFollowUpClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("https://services-fluids-dev.sekoia.one", baseUrl);
    }

    post(request: CreateRegistrationFollowUpRequest): Promise<RegistrationFollowUpResponse> {
        let url_ = this.baseUrl + "/api/registrationFollowUps";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<RegistrationFollowUpResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = RegistrationFollowUpResponse.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RegistrationFollowUpResponse>(<any>null);
    }

    getRegistrationFollowUpById(residentId: string | null, id: number): Promise<RegistrationFollowUpResponse> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/registrationFollowUps/{id}";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetRegistrationFollowUpById(_response);
        });
    }

    protected processGetRegistrationFollowUpById(response: Response): Promise<RegistrationFollowUpResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegistrationFollowUpResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RegistrationFollowUpResponse>(<any>null);
    }

    getRegistrationFollowUpsForResidents(request: GetRegistrationFollowUpsForResidentsRequest): Promise<RegistrationFollowUpResponse[]> {
        let url_ = this.baseUrl + "/api/registrationFollowUps/query";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetRegistrationFollowUpsForResidents(_response);
        });
    }

    protected processGetRegistrationFollowUpsForResidents(response: Response): Promise<RegistrationFollowUpResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RegistrationFollowUpResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RegistrationFollowUpResponse[]>(<any>null);
    }
}

export class FluidTypeClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("https://services-fluids-dev.sekoia.one", baseUrl);
    }

    getFluidTypes(): Promise<FluidTypeResponse[]> {
        let url_ = this.baseUrl + "/api/fluidTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFluidTypes(_response);
        });
    }

    protected processGetFluidTypes(response: Response): Promise<FluidTypeResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FluidTypeResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FluidTypeResponse[]>(<any>null);
    }

    createFluidType(createFluidTypeRequest: CreateFluidTypeRequest): Promise<FluidTypeResponse> {
        let url_ = this.baseUrl + "/api/fluidTypes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createFluidTypeRequest);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateFluidType(_response);
        });
    }

    protected processCreateFluidType(response: Response): Promise<FluidTypeResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = FluidTypeResponse.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FluidTypeResponse>(<any>null);
    }

    updateFluidType(id: number, updateFluidTypeRequest: UpdateFluidTypeRequest): Promise<FluidTypeResponse> {
        let url_ = this.baseUrl + "/api/fluidTypes/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateFluidTypeRequest);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateFluidType(_response);
        });
    }

    protected processUpdateFluidType(response: Response): Promise<FluidTypeResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FluidTypeResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FluidTypeResponse>(<any>null);
    }

    removeFluidType(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/fluidTypes/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRemoveFluidType(_response);
        });
    }

    protected processRemoveFluidType(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class TargetValueResponse implements ITargetValueResponse {
    residentId?: string | undefined;
    target!: number;
    timeOfCreation!: moment.Moment;

    constructor(data?: ITargetValueResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.residentId = _data["residentId"];
            this.target = _data["target"];
            this.timeOfCreation = _data["timeOfCreation"] ? moment(_data["timeOfCreation"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): TargetValueResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TargetValueResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["residentId"] = this.residentId;
        data["target"] = this.target;
        data["timeOfCreation"] = this.timeOfCreation ? this.timeOfCreation.toISOString() : <any>undefined;
        return data; 
    }
}

export interface ITargetValueResponse {
    residentId?: string | undefined;
    target: number;
    timeOfCreation: moment.Moment;
}

export class GetTargetValuesForResidentsRequest implements IGetTargetValuesForResidentsRequest {
    residentIds?: string[] | undefined;

    constructor(data?: IGetTargetValuesForResidentsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["residentIds"])) {
                this.residentIds = [] as any;
                for (let item of _data["residentIds"])
                    this.residentIds!.push(item);
            }
        }
    }

    static fromJS(data: any): GetTargetValuesForResidentsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetTargetValuesForResidentsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.residentIds)) {
            data["residentIds"] = [];
            for (let item of this.residentIds)
                data["residentIds"].push(item);
        }
        return data; 
    }
}

export interface IGetTargetValuesForResidentsRequest {
    residentIds?: string[] | undefined;
}

export class CreateTargetValueRequest implements ICreateTargetValueRequest {
    residentId?: string | undefined;
    target!: number;
    employeeId?: string | undefined;

    constructor(data?: ICreateTargetValueRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.residentId = _data["residentId"];
            this.target = _data["target"];
            this.employeeId = _data["employeeId"];
        }
    }

    static fromJS(data: any): CreateTargetValueRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTargetValueRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["residentId"] = this.residentId;
        data["target"] = this.target;
        data["employeeId"] = this.employeeId;
        return data; 
    }
}

export interface ICreateTargetValueRequest {
    residentId?: string | undefined;
    target: number;
    employeeId?: string | undefined;
}

export enum ReportType {
    Csv = "Csv",
    Pdf = "Pdf",
}

export class RegistrationResponse implements IRegistrationResponse {
    id!: number;
    volumeInMl!: number;
    comment?: string | undefined;
    offeredUnknown!: boolean;
    residentId?: string | undefined;
    fluidType?: string | undefined;
    timeOfCreation!: moment.Moment;
    timeOfRegistration!: moment.Moment;
    requiresFollowUp!: boolean;
    customerId?: string | undefined;
    employeeId?: string | undefined;
    followUpState?: string | undefined;
    lastUpdated!: moment.Moment;
    fluidAmountConsumed!: number;
    unknownTimeOffered!: boolean;

    constructor(data?: IRegistrationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.volumeInMl = _data["volumeInMl"];
            this.comment = _data["comment"];
            this.offeredUnknown = _data["offeredUnknown"];
            this.residentId = _data["residentId"];
            this.fluidType = _data["fluidType"];
            this.timeOfCreation = _data["timeOfCreation"] ? moment(_data["timeOfCreation"].toString()) : <any>undefined;
            this.timeOfRegistration = _data["timeOfRegistration"] ? moment(_data["timeOfRegistration"].toString()) : <any>undefined;
            this.requiresFollowUp = _data["requiresFollowUp"];
            this.customerId = _data["customerId"];
            this.employeeId = _data["employeeId"];
            this.followUpState = _data["followUpState"];
            this.lastUpdated = _data["lastUpdated"] ? moment(_data["lastUpdated"].toString()) : <any>undefined;
            this.fluidAmountConsumed = _data["fluidAmountConsumed"];
            this.unknownTimeOffered = _data["unknownTimeOffered"];
        }
    }

    static fromJS(data: any): RegistrationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RegistrationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["volumeInMl"] = this.volumeInMl;
        data["comment"] = this.comment;
        data["offeredUnknown"] = this.offeredUnknown;
        data["residentId"] = this.residentId;
        data["fluidType"] = this.fluidType;
        data["timeOfCreation"] = this.timeOfCreation ? this.timeOfCreation.toISOString() : <any>undefined;
        data["timeOfRegistration"] = this.timeOfRegistration ? this.timeOfRegistration.toISOString() : <any>undefined;
        data["requiresFollowUp"] = this.requiresFollowUp;
        data["customerId"] = this.customerId;
        data["employeeId"] = this.employeeId;
        data["followUpState"] = this.followUpState;
        data["lastUpdated"] = this.lastUpdated ? this.lastUpdated.toISOString() : <any>undefined;
        data["fluidAmountConsumed"] = this.fluidAmountConsumed;
        data["unknownTimeOffered"] = this.unknownTimeOffered;
        return data; 
    }
}

export interface IRegistrationResponse {
    id: number;
    volumeInMl: number;
    comment?: string | undefined;
    offeredUnknown: boolean;
    residentId?: string | undefined;
    fluidType?: string | undefined;
    timeOfCreation: moment.Moment;
    timeOfRegistration: moment.Moment;
    requiresFollowUp: boolean;
    customerId?: string | undefined;
    employeeId?: string | undefined;
    followUpState?: string | undefined;
    lastUpdated: moment.Moment;
    fluidAmountConsumed: number;
    unknownTimeOffered: boolean;
}

export class GetRegistrationsForResidentsRequest implements IGetRegistrationsForResidentsRequest {
    residentIds?: string[] | undefined;
    from!: moment.Moment;
    to!: moment.Moment;

    constructor(data?: IGetRegistrationsForResidentsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["residentIds"])) {
                this.residentIds = [] as any;
                for (let item of _data["residentIds"])
                    this.residentIds!.push(item);
            }
            this.from = _data["from"] ? moment(_data["from"].toString()) : <any>undefined;
            this.to = _data["to"] ? moment(_data["to"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetRegistrationsForResidentsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetRegistrationsForResidentsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.residentIds)) {
            data["residentIds"] = [];
            for (let item of this.residentIds)
                data["residentIds"].push(item);
        }
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IGetRegistrationsForResidentsRequest {
    residentIds?: string[] | undefined;
    from: moment.Moment;
    to: moment.Moment;
}

export class CreateRegistrationRequest implements ICreateRegistrationRequest {
    volumeInMl!: number;
    offeredUnknown!: boolean;
    employeeId?: string | undefined;
    residentId?: string | undefined;
    fluidType?: string | undefined;
    timeOfRegistration!: moment.Moment;
    requiresFollowUp!: boolean;
    followUpTimeTo!: moment.Moment;
    followUpTimeFrom!: moment.Moment;
    fluidAmountConsumed!: number;
    comment?: string | undefined;
    unknownTimeOffered!: boolean;

    constructor(data?: ICreateRegistrationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.volumeInMl = _data["volumeInMl"];
            this.offeredUnknown = _data["offeredUnknown"];
            this.employeeId = _data["employeeId"];
            this.residentId = _data["residentId"];
            this.fluidType = _data["fluidType"];
            this.timeOfRegistration = _data["timeOfRegistration"] ? moment(_data["timeOfRegistration"].toString()) : <any>undefined;
            this.requiresFollowUp = _data["requiresFollowUp"];
            this.followUpTimeTo = _data["followUpTimeTo"] ? moment(_data["followUpTimeTo"].toString()) : <any>undefined;
            this.followUpTimeFrom = _data["followUpTimeFrom"] ? moment(_data["followUpTimeFrom"].toString()) : <any>undefined;
            this.fluidAmountConsumed = _data["fluidAmountConsumed"];
            this.comment = _data["comment"];
            this.unknownTimeOffered = _data["unknownTimeOffered"];
        }
    }

    static fromJS(data: any): CreateRegistrationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRegistrationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["volumeInMl"] = this.volumeInMl;
        data["offeredUnknown"] = this.offeredUnknown;
        data["employeeId"] = this.employeeId;
        data["residentId"] = this.residentId;
        data["fluidType"] = this.fluidType;
        data["timeOfRegistration"] = this.timeOfRegistration ? this.timeOfRegistration.toISOString() : <any>undefined;
        data["requiresFollowUp"] = this.requiresFollowUp;
        data["followUpTimeTo"] = this.followUpTimeTo ? this.followUpTimeTo.toISOString() : <any>undefined;
        data["followUpTimeFrom"] = this.followUpTimeFrom ? this.followUpTimeFrom.toISOString() : <any>undefined;
        data["fluidAmountConsumed"] = this.fluidAmountConsumed;
        data["comment"] = this.comment;
        data["unknownTimeOffered"] = this.unknownTimeOffered;
        return data; 
    }
}

export interface ICreateRegistrationRequest {
    volumeInMl: number;
    offeredUnknown: boolean;
    employeeId?: string | undefined;
    residentId?: string | undefined;
    fluidType?: string | undefined;
    timeOfRegistration: moment.Moment;
    requiresFollowUp: boolean;
    followUpTimeTo: moment.Moment;
    followUpTimeFrom: moment.Moment;
    fluidAmountConsumed: number;
    comment?: string | undefined;
    unknownTimeOffered: boolean;
}

export class RegistrationFollowUpResponse implements IRegistrationFollowUpResponse {
    id!: number;
    volumeConsumedInMl!: number;
    registrationId!: number;
    residentId?: string | undefined;
    employeeId?: string | undefined;
    comment?: string | undefined;
    registration?: RegistrationResponse | undefined;
    customerId?: string | undefined;
    from!: moment.Moment;
    to!: moment.Moment;
    followUpState?: string | undefined;
    lastUpdated!: moment.Moment;
    timeOfCreation!: moment.Moment;

    constructor(data?: IRegistrationFollowUpResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.volumeConsumedInMl = _data["volumeConsumedInMl"];
            this.registrationId = _data["registrationId"];
            this.residentId = _data["residentId"];
            this.employeeId = _data["employeeId"];
            this.comment = _data["comment"];
            this.registration = _data["registration"] ? RegistrationResponse.fromJS(_data["registration"]) : <any>undefined;
            this.customerId = _data["customerId"];
            this.from = _data["from"] ? moment(_data["from"].toString()) : <any>undefined;
            this.to = _data["to"] ? moment(_data["to"].toString()) : <any>undefined;
            this.followUpState = _data["followUpState"];
            this.lastUpdated = _data["lastUpdated"] ? moment(_data["lastUpdated"].toString()) : <any>undefined;
            this.timeOfCreation = _data["timeOfCreation"] ? moment(_data["timeOfCreation"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): RegistrationFollowUpResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RegistrationFollowUpResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["volumeConsumedInMl"] = this.volumeConsumedInMl;
        data["registrationId"] = this.registrationId;
        data["residentId"] = this.residentId;
        data["employeeId"] = this.employeeId;
        data["comment"] = this.comment;
        data["registration"] = this.registration ? this.registration.toJSON() : <any>undefined;
        data["customerId"] = this.customerId;
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        data["followUpState"] = this.followUpState;
        data["lastUpdated"] = this.lastUpdated ? this.lastUpdated.toISOString() : <any>undefined;
        data["timeOfCreation"] = this.timeOfCreation ? this.timeOfCreation.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IRegistrationFollowUpResponse {
    id: number;
    volumeConsumedInMl: number;
    registrationId: number;
    residentId?: string | undefined;
    employeeId?: string | undefined;
    comment?: string | undefined;
    registration?: RegistrationResponse | undefined;
    customerId?: string | undefined;
    from: moment.Moment;
    to: moment.Moment;
    followUpState?: string | undefined;
    lastUpdated: moment.Moment;
    timeOfCreation: moment.Moment;
}

export class CreateRegistrationFollowUpRequest implements ICreateRegistrationFollowUpRequest {
    id!: number;
    volumeConsumedInMl!: number;
    residentId?: string | undefined;
    employeeId?: string | undefined;
    comment?: string | undefined;

    constructor(data?: ICreateRegistrationFollowUpRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.volumeConsumedInMl = _data["volumeConsumedInMl"];
            this.residentId = _data["residentId"];
            this.employeeId = _data["employeeId"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): CreateRegistrationFollowUpRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRegistrationFollowUpRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["volumeConsumedInMl"] = this.volumeConsumedInMl;
        data["residentId"] = this.residentId;
        data["employeeId"] = this.employeeId;
        data["comment"] = this.comment;
        return data; 
    }
}

export interface ICreateRegistrationFollowUpRequest {
    id: number;
    volumeConsumedInMl: number;
    residentId?: string | undefined;
    employeeId?: string | undefined;
    comment?: string | undefined;
}

export class GetRegistrationFollowUpsForResidentsRequest implements IGetRegistrationFollowUpsForResidentsRequest {
    residentIds?: string[] | undefined;
    from!: moment.Moment;
    to!: moment.Moment;

    constructor(data?: IGetRegistrationFollowUpsForResidentsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["residentIds"])) {
                this.residentIds = [] as any;
                for (let item of _data["residentIds"])
                    this.residentIds!.push(item);
            }
            this.from = _data["from"] ? moment(_data["from"].toString()) : <any>undefined;
            this.to = _data["to"] ? moment(_data["to"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetRegistrationFollowUpsForResidentsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetRegistrationFollowUpsForResidentsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.residentIds)) {
            data["residentIds"] = [];
            for (let item of this.residentIds)
                data["residentIds"].push(item);
        }
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IGetRegistrationFollowUpsForResidentsRequest {
    residentIds?: string[] | undefined;
    from: moment.Moment;
    to: moment.Moment;
}

export class FluidTypeResponse implements IFluidTypeResponse {
    customerId?: string | undefined;
    id!: number;
    type?: string | undefined;
    isDeleted!: boolean;

    constructor(data?: IFluidTypeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerId = _data["customerId"];
            this.id = _data["id"];
            this.type = _data["type"];
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): FluidTypeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FluidTypeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        data["id"] = this.id;
        data["type"] = this.type;
        data["isDeleted"] = this.isDeleted;
        return data; 
    }
}

export interface IFluidTypeResponse {
    customerId?: string | undefined;
    id: number;
    type?: string | undefined;
    isDeleted: boolean;
}

export class CreateFluidTypeRequest implements ICreateFluidTypeRequest {
    type?: string | undefined;

    constructor(data?: ICreateFluidTypeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): CreateFluidTypeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFluidTypeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        return data; 
    }
}

export interface ICreateFluidTypeRequest {
    type?: string | undefined;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    extensions!: { [key: string]: any; };

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.extensions = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
            if (_data["extensions"]) {
                this.extensions = {} as any;
                for (let key in _data["extensions"]) {
                    if (_data["extensions"].hasOwnProperty(key))
                        (<any>this.extensions)![key] = _data["extensions"][key];
                }
            }
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        if (this.extensions) {
            data["extensions"] = {};
            for (let key in this.extensions) {
                if (this.extensions.hasOwnProperty(key))
                    (<any>data["extensions"])[key] = this.extensions[key];
            }
        }
        return data; 
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    extensions: { [key: string]: any; };
}

export class UpdateFluidTypeRequest implements IUpdateFluidTypeRequest {
    type?: string | undefined;

    constructor(data?: IUpdateFluidTypeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): UpdateFluidTypeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFluidTypeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        return data; 
    }
}

export interface IUpdateFluidTypeRequest {
    type?: string | undefined;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}